<template>
  <div id="vanber">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>岗位管理</el-breadcrumb-item>
      <el-breadcrumb-item>岗位发布</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <el-tabs v-model="active" style="margin: 14px 0;">
      <el-tab-pane label="招聘中" name="recruiting"></el-tab-pane>
      <el-tab-pane label="已下线" name="recruited"></el-tab-pane>
    </el-tabs>-->
    <v-recruiting></v-recruiting>
    <!-- <v-recruiting v-if="active === 'recruiting'"></v-recruiting> -->
    <!-- <v-recruited v-else></v-recruited> -->
  </div>
</template>

<script>
import Recruiting from "./components/Recruiting";

export default {
  components: {
    "v-recruiting": Recruiting
  },
  data() {
    return {
      // active: 'recruiting',
    };
  },

  methods: {}
};
</script>

<style scoped lang="scss">
#vanber {
  position: relative;
  padding: 20px;
  .el-breadcrumb {
    margin-bottom: 30px;
  }
}
</style>
